import { Typography } from "@mui/material";
import { translate } from "./translations/translations";

export function translatedModalContent(path: string, values: Record<string, any>) {
  let paragraphs = [];
  let paragraph = "";
  let i = 0;

  do {
    paragraph = translate(`${path}[${i}]`, values, "");
    if (paragraph) {
      paragraphs.push(
        <Typography key={i} sx={{
          marginBottom: "16px"
        }}>
          {paragraph}
        </Typography>
      );
      i++;
    }
  } while (paragraph);

  return <>{paragraphs}</>;
}
